import { useContext } from 'react';
import { PublicDataContext } from '../context/PublicDataProvider';

export const usePublicData = () => {
  const context = useContext(PublicDataContext);

  if (context === null) {
    throw new Error('Public Data context must come from PublicDataProvider');
  }
  return context;
};
